import React from 'react'
import { TouchableOpacity, View, Text, Platform } from 'react-native'
import { FontAwesome5 } from '@expo/vector-icons'
import { useTheme } from '@ui-kitten/components'

export default function HeaderIconButton( { iconName, text, onPress, selected, style, width=70, disabled=false, testID} ) {
  const theme = useTheme()
  const activeColor = selected ? theme['color-primary-500'] : theme['text-hint-color']
  const activeBg = selected ? theme['color-primary-500'] + '14' : theme['text-hint-color'] + '14'

  return (
    <TouchableOpacity
      style={{width: width}}
      onPress={onPress}
      disabled={disabled}
      testID={testID}
      {...(Platform.OS === 'web' && testID ? { dataSet: { testid: testID } } : {})}
    >
      <View style={[{height: 50, borderRadius: 4, borderWidth: 1, alignItems: 'center', borderColor: activeColor, justifyContent: 'center', backgroundColor: activeBg}, style]}>
        <FontAwesome5 style={{marginTop: 3}} name={iconName} size={16} color={activeColor} />
        <Text style={{color: activeColor, fontSize: 11, fontWeight: '600' }}>{text}</Text>
      </View>
    </TouchableOpacity>
  )
}
